module.exports = __webpack_public_path__ + "static/media/HCMM582.1b365d73.jpg";